/* Danella launch special. Two automatic Shopify discounts run during the launch: a flat percent off every single product and a smaller percent off the routines and sets that carry the product tag 'DL sale routine' (the Shopify discount "Sale: 10% off routines" follows that same tag through the collection "Sale: routines 10% (internal)").
   ONE OFFER AT A TIME: while the sale runs, the spend-more-save-more levels (10% off $50+, 15% off $90+, 20% off $110+) are hidden everywhere (the Liquid files check snippets/dl-sale-on.liquid) so shoppers only see the sale. They come back when the sale ends.
   This file adds the "Sale" layer:
   the launch price with the regular price crossed out (product pages, Add to bag button, product cards), a sale box on product pages, a sale line on the home page,
   a sale line at the top of the bag (instead of the "spend $X more" progress), the announcement bar wording,
   two teal sale bubbles beside the logo (wide screens, every page except the home page, where the pink and black hero bubbles carry the sale) and a sale line in the home hero.
   It switches itself on at START (the same minute the two Shopify discounts "Launch: 20% off singles" and "Launch: 10% off routines" start) and off when the
   shop metafield danella.launch_end (read in sections/danella-v4-global.liquid) is reached, so ending the launch needs no theme change: set that metafield to
   the stop time and end the two discounts. In an unpublished preview of the theme it is always on.
   To undo completely: delete the two launch lines (one stylesheet, one script) in sections/danella-v4-global.liquid. */
(function(){
  /* Sale window: starts at the shop metafield danella.launch_start (same minute as the two Shopify discounts; falls back to Sun Oct 18 2026 12:00 AM PT) and has no fixed end:
     it runs until the owner says stop (shop metafield danella.launch_end). Both are printed by sections/danella-v4-global.liquid. */
  var START = Date.parse('2026-10-18T07:00:00Z');
  var END = Infinity;
  try {
    var cfgL = window.DanellaLaunch || {};
    if (cfgL.start && !isNaN(Date.parse(cfgL.start))) START = Date.parse(cfgL.start);
    if (cfgL.end && !isNaN(Date.parse(cfgL.end))) END = Date.parse(cfgL.end);
  } catch (e) {}
  var role = '';
  try { role = (window.Shopify && window.Shopify.theme && window.Shopify.theme.role) || ''; } catch (e) {}
  var preview = role !== '' && role !== 'main';
  var nowMs = Date.now();
  if (nowMs < START || nowMs >= END) return;

  var L = { on: true, pct: 20, rpct: 10, label: 'Sale' };
  if (!L.on) return;
  /* Other scripts (the skin quiz) read the live sale percents from here. */
  window.DanellaSale = { single: L.pct, routine: L.rpct };
  /* The first seven are the original concern routines (kept as a fallback); every set that is in the sale also carries data-dl-routine on its price (snippets/price.liquid). */
  var ROUTINES = ['acne-blemish-routine','pores-texture-routine','dark-spots-even-tone-routine','dullness-glow-routine','dryness-hydration-routine','redness-barrier-routine','firming-fine-lines-routine'];
  var cfg = window.DanellaV4 = window.DanellaV4 || {};
  var ss = cfg.spendSave = cfg.spendSave || {};
  /* The bag drops its "spend $X more to unlock" progress while the launch special runs (it would say 10% while the bag already gives 20%). */
  ss.enabled = false;

  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function handleOf(a){ return a ? (String(a.getAttribute('href') || '').split('/products/')[1] || '').split('?')[0].split('#')[0] : ''; }
  function isRoutineLink(el){
    var c = el && el.closest && el.closest('.product-card');
    if (c && c.querySelector('.price[data-dl-routine]')) return true;
    var a = c && c.querySelector('a[href*="/products/"]');
    return ROUTINES.indexOf(handleOf(a)) > -1;
  }
  function cents(t){ var m = String(t || '').replace(/,/g, '').match(/\d+(?:\.\d+)?/); return m ? Math.round(parseFloat(m[0]) * 100) : 0; }
  function money(c){ return '$' + (c / 100).toFixed(2); }
  function off(c, pct){ return c - Math.round(c * pct / 100); }
  function watch(el, fn){ try { var o = new MutationObserver(fn); o.observe(el, { childList: true, characterData: true, subtree: true }); return o; } catch (e) { return null; } }

  /* Announcement bar wording (matched by its current text, so a changed bar is simply left alone). The "Order by 2pm PT" line stays as it is: one offer at a time. */
  function announce(){
    document.querySelectorAll('.sb-announce__msg').forEach(function(p){
      if (p.getAttribute('data-dl')) return;
      var t = (p.textContent || '').replace(/\s+/g, ' ').trim(), n = '';
      if (/^Spend more, save more/i.test(t)) n = L.label + ': ' + L.pct + '% off every single, ' + L.rpct + '% off routines';
      if (!n) return;
      p.setAttribute('data-dl', '1');
      var a = p.querySelector('a');
      (a || p).textContent = n;
    });
  }

  /* Product cards and the home page section. */
  function words(){
    document.querySelectorAll('.sb-ss').forEach(function(p){
      if (p.getAttribute('data-dl')) return;
      p.setAttribute('data-dl', '1');
      var pct = isRoutineLink(p) ? L.rpct : L.pct;
      p.setAttribute('aria-label', L.label + ': ' + pct + '% off');
      p.innerHTML = '<span><b>' + pct + '%</b> off · sale</span>';
    });
    document.querySelectorAll('.sb-ladder__sub').forEach(function(sub){
      if (sub.getAttribute('data-dl')) return;
      sub.setAttribute('data-dl', '1');
      sub.innerHTML = '<b>Sale:</b> every single is ' + L.pct + '% off and routines are ' + L.rpct + '% off for a limited time, no minimum. Free U.S. shipping $35+, $5.95 under.';
    });
  }

  /* The price itself: launch price first, regular price crossed out next to it. The theme's own price stays in the page (hidden) so its scripts keep working. */
  function priceRow(wrap, pct){
    if (!wrap || wrap.getAttribute('data-dl')) return;
    var cur = wrap.querySelector('[data-product-price]');
    if (!cur) return;
    wrap.setAttribute('data-dl', '1');
    wrap.classList.add('dl-on');
    var box = document.createElement('span');
    box.className = 'dl-price';
    box.innerHTML = '<span class="price__current dl-now"></span><s class="price__compare dl-was"></s><span class="price__badge dl-pill">' + L.label + ' · ' + pct + '% off</span>';
    wrap.insertBefore(box, wrap.firstChild);
    var now = box.querySelector('.dl-now'), was = box.querySelector('.dl-was');
    var paint = function(){
      var c = cents(cur.textContent);
      if (!c) return;
      var n = money(off(c, pct)), w = money(c);
      if (now.textContent !== n) now.textContent = n;
      if (was.textContent !== w) was.textContent = w;
    };
    paint();
    watch(cur, paint);
  }
  /* The Add to bag button shows the launch total too. */
  function buttonPrice(pct){
    document.querySelectorAll('[data-button-price]').forEach(function(bp){
      if (bp.getAttribute('data-dl')) return;
      bp.setAttribute('data-dl', '1');
      var m = document.createElement('span');
      m.className = 'dl-btn';
      bp.insertAdjacentElement('afterend', m);
      bp.classList.add('dl-hide');
      var paint = function(){ var c = cents(bp.textContent); if (c) { var t = money(off(c, pct)); if (m.textContent !== t) m.textContent = t; } };
      paint();
      watch(bp, paint);
    });
  }
  /* Routine pages: the "$18.67 per product" pill follows the launch price (the theme's own pill stays, hidden, and a copy shows the launch number). */
  function perProduct(pct){
    document.querySelectorAll('.main-product .price__per:not(.dl-per)').forEach(function(el){
      if (el.getAttribute('data-dl')) return;
      el.setAttribute('data-dl', '1');
      var m = document.createElement('span');
      m.className = el.className + ' dl-per';
      el.insertAdjacentElement('afterend', m);
      el.classList.add('dl-hide');
      var paint = function(){
        var t = el.textContent, mm = t.match(/\$(\d+(?:\.\d+)?)/);
        if (!mm) { if (m.textContent !== t) m.textContent = t; return; }
        var nt = t.replace(mm[0], money(off(Math.round(parseFloat(mm[1]) * 100), pct)));
        if (m.textContent !== nt) m.textContent = nt;
      };
      paint();
      watch(el, paint);
      /* If the theme hides the pill (no per-product number), hide the copy too. */
      var vis = function(){ m.hidden = el.hidden; };
      vis();
      try { new MutationObserver(vis).observe(el, { attributes: true, attributeFilter: ['hidden'] }); } catch (e) {}
    });
  }
  function cards(){
    document.querySelectorAll('.product-card').forEach(function(card){
      var wrap = card.querySelector('.price[data-price-wrap]');
      if (!wrap) return;
      var pct = card.querySelector('.sb-ss') ? L.pct : (isRoutineLink(card) ? L.rpct : 0);
      if (pct) priceRow(wrap, pct);
    });
  }

  /* Product pages: ONE sale box under Add to bag (routines and singles). It replaces the spend-more-save-more box if the theme drew one. */
  function routineBox(pct, single){
    var lad = document.querySelector('.main-product .v4-ladder');
    if (lad && lad.classList.contains('v4-ladder--launch')) return;
    if (!lad) {
      var form = document.querySelector('.main-product .product-info__sticky form.product-form');
      if (!form) return;
      lad = document.createElement('div');
      form.insertAdjacentElement('afterend', lad);
    }
    lad.className = 'v4-ladder v4-ladder--price v4-ladder--launch';
    lad.innerHTML = '<div class="v4-ladder__head"><p class="v4-ladder__title">' + L.label + '</p><p class="v4-ladder__cap">' + (single ? 'Your price' : 'Your routine price') + '</p></div>' +
      '<div class="v4-ladder__steps"><div class="v4-ladder__step"><b>' + pct + '% off</b><span>Sale price</span><s class="v4-ladder__was"></s><em class="v4-ladder__price"></em></div></div>' +
      '<p class="v4-ladder__note">Applied automatically in your bag. No code needed.</p>';
    var info = document.querySelector('.main-product .product-info__sticky') || document;
    var priceEl = info.querySelector('[data-product-price]');
    var cell = lad.querySelector('.v4-ladder__step');
    var paint = function(){
      var c = cents(priceEl && priceEl.textContent);
      var now = c > 0 ? money(off(c, pct)) : '', was = c > 0 ? money(c) : '';
      var pe = cell.querySelector('.v4-ladder__price'), we = cell.querySelector('.v4-ladder__was');
      if (pe && pe.textContent !== now) pe.textContent = now;
      if (we && we.textContent !== was) we.textContent = was;
    };
    paint();
    if (priceEl) watch(priceEl, paint);
  }

  function page(){
    var pct = 0;
    var h = (window.location.pathname.split('/products/')[1] || '').split('/')[0];
    var lad = document.querySelector('.main-product .v4-ladder--price:not(.v4-ladder--launch)');
    var wrapEl = document.querySelector('.main-product .product-info__sticky .price[data-price-wrap]');
    /* A set is in the sale when its price wrap carries data-dl-routine (product tag 'DL sale routine'); the seven original concern routines also match by handle. */
    var isR = !!(wrapEl && wrapEl.hasAttribute('data-dl-routine')) || ROUTINES.indexOf(h) > -1;
    if (!isR && (lad || (h && cfg.tierPrices))) {
      /* Single product: the sale box replaces the spend-more-save-more box (one offer at a time). */
      pct = L.pct;
      routineBox(pct, true);
    } else {
      if (!isR) {
        /* A set that is not in the sale (for example the Glow Box, which is already priced below its products one by one): the spend-more-save-more box would promise discounts that are switched off while the sale runs, so it is removed. */
        var stale = document.querySelector('.main-product .v4-ladder:not(.v4-ladder--launch)');
        if (stale && stale.parentNode) stale.parentNode.removeChild(stale);
        return false;
      }
      pct = L.rpct;
      routineBox(pct);
    }
    priceRow(wrapEl, pct);
    buttonPrice(pct);
    perProduct(pct);
    return true;
  }

  /* The size buttons on routine pages show "Save $X" pills that compare against the regular price. During the sale that would overstate what a shopper saves (the sale price is already shown), so those pills are hidden. */
  function hideSave(){
    var root = document.querySelector('.main-product');
    if (!root) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, hits = [];
    while ((n = w.nextNode())) { if (/^\s*Save \$[\d,.]+\s*$/.test(n.nodeValue)) hits.push(n); }
    hits.forEach(function(t){
      var p = t.parentNode;
      if (p && p !== root && (p.textContent || '').replace(/\s+/g, ' ').trim() === t.nodeValue.trim()) p.classList.add('dl-hide');
      else t.nodeValue = '';
    });
  }

  /* Set descriptions compare the set price with the singles bought one by one ("$211 bought one by one, the box is $129, you save $82"). While the singles are 20% off, that comparison is no longer today's price, so it is labelled as everyday prices. It goes back to the plain wording by itself when the sale ends (this file stops running). */
  function descLabel(){
    document.querySelectorAll('.v4-intro__text, .product-accordions .rte').forEach(function(root){
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
      while ((n = w.nextNode())) {
        var v = n.nodeValue;
        if (/at everyday prices/i.test(v)) continue;
        var nv = v.replace(/(if bought separately|bought separately|bought one by one|one by one)/i, '$1 at everyday prices');
        if (nv !== v) n.nodeValue = nv;
      }
    });
  }

  /* The bag: one sale line at the top instead of the "spend $X more" progress. */
  function bag(){
    var body = document.querySelector('#V4Cart [data-v4c-body]');
    if (!body || body.querySelector('.dl-bag') || body.querySelector('.v4c__empty') || !body.querySelector('.v4c__items')) return;
    var d = document.createElement('div');
    d.className = 'v4c__prog dl-bag';
    d.innerHTML = '<p class="v4c__msg"><b>Sale:</b> ' + L.pct + '% off every single and ' + L.rpct + '% off routines, applied below.</p>';
    body.insertBefore(d, body.firstChild);
  }


  /* Teal sale bubbles on each side of the logo (wide screens only; phones and tablets get the bar on top and the home page line) and a sale line in the home hero. */
  function styles(){
    if (document.getElementById('dl-sale-css')) return;
    var st = document.createElement('style');
    st.id = 'dl-sale-css';
    st.textContent =
      '.main-product .dl-hide{display:none!important}' +
      '.sb-header__main{position:relative}' +
      'html body a.dl-bub:not(#_){position:absolute;top:50%;transform:translateY(-50%);display:none;flex-direction:column;align-items:center;justify-content:center;gap:2px;padding:9px 28px 10px;border-radius:30px;background:#B2D9D9;color:#111;text-decoration:none;line-height:1.1;text-align:center;white-space:nowrap;z-index:2;transition:background .15s,color .15s}' +
      'html body a.dl-bub:not(#_):hover{background:#111;color:#fff}' +
      'a.dl-bub i{font-style:normal;font-size:11px;font-weight:700;letter-spacing:.14em;text-transform:uppercase}' +
      'a.dl-bub b{font-size:28px;font-weight:700;letter-spacing:-.01em}' +
      'a.dl-bub span{font-size:14px;font-weight:600}' +
      '@media (min-width:1400px){html body a.dl-bub:not(#_){display:flex}}' +
      /* Splash: each bubble drops in, squashes as it lands, springs back, and sends a ring and a few droplets out. */
      'a.dl-bub.dl-anim{animation:dl-drop .95s cubic-bezier(.3,.7,.4,1) .35s both}' +
      'a.dl-bub--r.dl-anim{animation-delay:.6s}' +
      'a.dl-bub.dl-anim::before{content:"";position:absolute;inset:0;border-radius:inherit;border:2px solid #8FC7C7;opacity:0;pointer-events:none;animation:dl-ring .8s ease-out .85s both}' +
      'a.dl-bub--r.dl-anim::before{animation-delay:1.1s}' +
      'a.dl-bub.dl-anim::after{content:"";position:absolute;left:50%;top:2px;width:6px;height:6px;margin-left:-3px;border-radius:50%;background:#8FC7C7;opacity:0;pointer-events:none;animation:dl-spray .75s ease-out .85s both}' +
      'a.dl-bub--r.dl-anim::after{animation-delay:1.1s}' +
      '@keyframes dl-drop{0%{opacity:0;transform:translateY(calc(-50% - 110px)) scale(.6)}12%{opacity:1}52%{opacity:1;transform:translateY(-50%) scale(1)}64%{transform:translateY(calc(-50% + 5px)) scale(1.2,.78)}80%{transform:translateY(calc(-50% - 7px)) scale(.94,1.08)}100%{opacity:1;transform:translateY(-50%) scale(1)}}' +
      '@keyframes dl-ring{0%{opacity:.9;transform:scale(1)}100%{opacity:0;transform:scale(1.5,1.9)}}' +
      '@keyframes dl-spray{0%{opacity:1;box-shadow:0 0 0 #8FC7C7,0 0 0 #8FC7C7,0 0 0 #8FC7C7,0 0 0 #8FC7C7}100%{opacity:0;box-shadow:-48px -22px 0 #8FC7C7,48px -22px 0 #8FC7C7,-26px -42px 0 #8FC7C7,26px -42px 0 #8FC7C7}}' +
      '@media (prefers-reduced-motion:reduce){a.dl-bub.dl-anim,a.dl-bub.dl-anim::before,a.dl-bub.dl-anim::after{animation:none!important}}' +
      'html body a.dl-hero:not(#_){display:inline-flex;align-self:flex-start;align-items:center;gap:10px;flex-wrap:wrap;width:fit-content;max-width:100%;margin:0 0 10px;padding:9px 16px 9px 10px;border-radius:999px;background:#B2D9D9;color:#111;text-decoration:none;font-size:clamp(14px,1.25vw,17px);line-height:1.25;font-weight:500}' +
      'a.dl-hero i{font-style:normal;background:#111;color:#fff;border-radius:999px;padding:3px 10px;font-size:11px;font-weight:700;letter-spacing:.12em;text-transform:uppercase}' +
      'a.dl-hero b{font-weight:700}' +
      'a.dl-hero em{font-style:normal;opacity:.5;margin:0 4px}';
    document.head.appendChild(st);
  }
  function placeBubbles(){
    var main = document.querySelector('.sb-header__main'), logo = main && main.querySelector('.sb-logo');
    var lb = main && main.querySelector('.dl-bub--l'), rb = main && main.querySelector('.dl-bub--r');
    if (!main || !logo || !lb || !rb) return;
    var m = main.getBoundingClientRect(), l = logo.getBoundingClientRect();
    lb.style.right = Math.round(m.right - l.left + 28) + 'px';
    rb.style.left = Math.round(l.right - m.left + 28) + 'px';
  }
  function bubbles(){
    var main = document.querySelector('.sb-header__main');
    if (!main || main.querySelector('.dl-bub')) return;
    /* The home page shows the sale in one place only: the pink and black bubbles in the hero card (see heroSplash). So no teal bubbles there. The splash flag is still set, so the teal bubbles do not drop in a second time on the next page of the visit. */
    if (document.body && document.body.classList.contains('template-index')) {
      try { window.sessionStorage.setItem('dlSplash', '1'); } catch (e) {}
      return;
    }
    main.insertAdjacentHTML('beforeend',
      '<a class="dl-bub dl-bub--l" href="/collections/single-products"><i>' + L.label + '</i><b>' + L.pct + '% off</b><span>every single</span></a>' +
      '<a class="dl-bub dl-bub--r" href="/pages/curated-routines"><i>' + L.label + '</i><b>' + L.rpct + '% off</b><span>routines</span></a>');
    var seen = false;
    try { seen = !!window.sessionStorage.getItem('dlSplash'); window.sessionStorage.setItem('dlSplash', '1'); } catch (e) {}
    if (window.location.pathname === '/' || !seen) main.querySelectorAll('.dl-bub').forEach(function(b){ b.classList.add('dl-anim'); });
    placeBubbles();
    window.addEventListener('resize', placeBubbles);
    window.addEventListener('load', placeBubbles);
    setTimeout(placeBubbles, 600);
    try { new ResizeObserver(placeBubbles).observe(main); } catch (e) {}
  }
  function hero(){
    var ul = document.querySelector('.sb-hero__deals');
    if (!ul || document.querySelector('.dl-hero')) return;
    var a = document.createElement('a');
    a.className = 'dl-hero';
    a.href = '/collections/single-products';
    a.innerHTML = '<i>' + L.label + '</i><span><b>' + L.pct + '% off</b> every single <em>·</em> <b>' + L.rpct + '% off</b> routines</span>';
    ul.insertAdjacentElement('beforebegin', a);
    /* The old list of spend-more-save-more levels under it stays hidden while the sale runs. */
    ul.hidden = true;
    ul.style.display = 'none';
  }
  /* Home hero: the pink and black sale bubbles drop in with the same splash as the teal header bubbles (the animation itself is in assets/danella-v71.css and plays on page load). When the card is below the first screen (phones), it is held back with the class dl-wait until the card scrolls into view, so the splash is seen and not played off screen. */
  function heroSplash(){
    var card = document.querySelector('.sb-hero .sb-ladder--launch');
    if (!card || card.getAttribute('data-dls')) return;
    card.setAttribute('data-dls', '1');
    if (!('IntersectionObserver' in window)) return;
    var r = card.getBoundingClientRect();
    if (r.top < window.innerHeight * 0.8) return;
    card.classList.add('dl-wait');
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting) { card.classList.remove('dl-wait'); io.disconnect(); }
      });
    }, { threshold: 0.6 });
    io.observe(card);
  }

  ready(function(){
    styles();
    bubbles();
    hero();
    heroSplash();
    announce();
    words();
    cards();
    if (!page()) setTimeout(page, 400);
    hideSave();
    setTimeout(hideSave, 400);
    descLabel();
    setTimeout(descLabel, 400);
    setTimeout(announce, 700);
    var tm = 0;
    try { new MutationObserver(function(){ clearTimeout(tm); tm = setTimeout(function(){ bubbles(); announce(); words(); cards(); hideSave(); descLabel(); }, 250); }).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    try { new MutationObserver(bag).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
  });
})();